import { render, staticRenderFns } from "./l200.vue?vue&type=template&id=d4983812&scoped=true"
import script from "./l200.vue?vue&type=script&lang=js"
export * from "./l200.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4983812",
  null
  
)

export default component.exports